let ProductDetails = () => import('../pages/ProductDetails.vue');
let ProductEstimate = () => import('../pages/ProductEstimate.vue');
let OrderApprovalConfirm = () => import('../pages/mypage/order/OrderApprovalConfirm.vue');
let ProductQuotation = () => import('../pages/ProductQuotation.vue');

export default [
    {
        path: '/embed/:slug',
        component: ProductDetails,
        name: 'ProductDetailsByEmbed',
        meta: { requiresAuth: false },
    },
    {
        path: '/embed/estimate/:slug',
        component: ProductEstimate,
        name: 'ProductEstimate',
        meta: { requiresAuth: false },
    },
    {
        // 견적서 미리보기. 데이터는 postMessage로 전달받음
        // /embed/ 로 시작해야 app.js가 헤더/푸터 없는 레이아웃을 사용함
        path: '/embed/quotation/preview',
        component: ProductQuotation,
        name: 'ProductQuotation',
        meta: { requiresAuth: true },
    },
    {
        path: '/m/approve/:id',
        component: OrderApprovalConfirm,
        name: 'OrderApprovalConfirm',
        meta: { requiresAuth: true },
    },
];
